import {
  isRadarFlightsResponseError,
  isRadarFlightsResultEmptyWithNotModified,
  isRadarResponse,
} from './radarFlightsResponse';

import type {
  RadarResponsePayload,
  RadarResponsePayloadSuccess,
  RadarResponsePayloadError,
} from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';

export type RadarResponseSuccess = RadarResponsePayloadSuccess;
type RadarResponseError = RadarResponsePayloadError;
export type RadarResponse = RadarResponsePayload;

export const isResponseContainFlightsBody = (response: RadarResponseSuccess) => {
  if (isRadarResponse(response) && isRadarFlightsResultEmptyWithNotModified(response)) {
    return false;
  }
  return !!response.body.itineraries;
};

export const getFlightsResponseBody = (response: RadarResponseSuccess) => response.body.itineraries;

export const isFlightsResponseError = (response: RadarResponse): response is RadarResponseError => {
  if (response.error) {
    return true;
  }

  return isRadarFlightsResponseError(response);
};
